import React, { useEffect, useState } from 'react';
import { CloseableModal } from '../../../components/CloseableModal';
import { ModalBody } from './ModalBody';
import { InterviewList } from '../../../entities/v1/applicant_tracking/InterviewList';
import { InterviewService } from '../../../services/v1/applicant_tracking/InterviewService';
import { InterviewTemplateList } from '../../../entities/v1/applicant_tracking/InterviewTemplate';
import { InterviewTemplateService } from '../../../services/v1/applicant_tracking/InterviewTemplateService';
import { JobHiringMemberList } from '../../../entities/v1/applicant_tracking/JobHiringMemberList';
import { JobHiringMemberService } from '../../../services/v1/applicant_tracking/JobHiringMemberService';

interface PropTypes {
  OnClose: () => void;
  isOpen: boolean;
  userId: number;
}

export function DeactivateUserModal(props: PropTypes) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [interviewList, setInterviewList] = useState<InterviewList>(null);
  const [interviewTemplateList, setInterviewTemplateList] =
    useState<InterviewTemplateList>(null);
  const [recruiterJobsList, setRecruiterJobsList] =
    useState<JobHiringMemberList>(null);

  useEffect(() => {
    setIsLoading(true);
    const interviewsPromise =
      InterviewService.listActiveFutureInterviewsForOrganizer(props.userId);

    const interviewTemplatesPromise =
      InterviewTemplateService.listInterviewTemplatesByOrganizerUser({
        organizerUserId: props.userId,
      });

    const recruiterJobsPromise =
      JobHiringMemberService.listRecruiterJobsForUser(props.userId);

    Promise.all([
      interviewsPromise,
      interviewTemplatesPromise,
      recruiterJobsPromise,
    ])
      .then(([interviews, templates, recruiterJobs]) => {
        setInterviewList(interviews);
        setInterviewTemplateList(templates);
        setRecruiterJobsList(recruiterJobs);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={() => props.OnClose()}
      isOpen={props.isOpen}
      size='md'
      closeDisabled={false}
      keyboard={true}
      backdrop={true}
      headerTitle={'Deactivate User'}
      bodyChildren={
        <ModalBody
          isLoading={isLoading}
          interviewTemplateList={interviewTemplateList}
          interviewList={interviewList}
          recruiterJobsList={recruiterJobsList}
          handleClose={props.OnClose}
          userId={props.userId}
          setIsLoading={setIsLoading}
        />
      }
    />
  );
}
